import { Link } from "react-router-dom";

/**
 * 프로필 허브 하위 페이지 공용 백링크 — CardDetailPage "← Collection" 문법
 * (ty-eyebrow, min-h-11 = 44px 타깃). 기본값은 My Hub(/profile) 복귀.
 */
export function BackLink({
  to = "/profile",
  label = "Back to my profile",
}: {
  to?: string;
  label?: string;
}) {
  return (
    <Link
      to={to}
      className="ty-eyebrow inline-flex min-h-11 w-fit items-center text-[10px] text-ink-mute transition-colors hover:text-ink"
    >
      ← {label}
    </Link>
  );
}
